export const FT_HDMS_DELIVERY_ADDRESS_MANAGEMENT = 'ldt_hdms_delivery_addresses_management';
